import { render, staticRenderFns } from "./UserIdComponent.vue?vue&type=template&id=766ab828&scoped=true"
import script from "./UserIdComponent.vue?vue&type=script&lang=js"
export * from "./UserIdComponent.vue?vue&type=script&lang=js"
import style0 from "./UserIdComponent.vue?vue&type=style&index=0&id=766ab828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766ab828",
  null
  
)

export default component.exports